export const HIGHLIGHT_TOOL_ID = "highlight";

const hexToRgba = (hex, alpha) => {
  const clean = (hex || "").replace("#", "");
  if (clean.length !== 6) {
    return `rgba(255, 235, 59, ${alpha})`;
  }

  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const highlightToolConfig = {
  id: HIGHLIGHT_TOOL_ID,
  usesPreview: false,
  cursor: "crosshair",
  onStart: () => true,
  onMove: ({ ctx, lastPointRef, nextPoint, penColor, penSize }) => {
    ctx.save();
    ctx.strokeStyle = hexToRgba(penColor, 0.35);
    ctx.lineWidth = Math.max(8, penSize * 3);
    ctx.beginPath();
    ctx.moveTo(lastPointRef.current.x, lastPointRef.current.y);
    ctx.lineTo(nextPoint.x, nextPoint.y);
    ctx.stroke();
    ctx.restore();
    lastPointRef.current = nextPoint;
  },
  onEnd: () => {},
};

const HighlightToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === HIGHLIGHT_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(HIGHLIGHT_TOOL_ID)}
      title="Highlight"
      aria-label="Highlight"
    >
      ✦
    </button>
  );
};

export default HighlightToolButton;
